import React, { useCallback, useContext, FunctionComponent } from 'react';
import PropTypes from 'prop-types';
import DownloadIcon from '@material-ui/icons/GetApp';
import {
    fetchRelatedRecords,
    useDataProvider,
    useNotify,
    Sort,
    DataProvider,
    ExporterContext,
} from 'ra-core';
import Button, { ButtonProps } from './Button';
import {makeStyles} from "@material-ui/core";
import {Theme} from "@material-ui/core/styles";


const useStyles = makeStyles(
    (theme: Theme) => ({
        button: {
            backgroundColor: theme.palette.primary.light,
            borderRadius: '0px',
            padding: '10px 5px 10px 5px',
            color: theme.palette.primary.dark,
            borderBottom: '1px solid',
            // @ts-ignore
            borderBottomColor: theme.overrides.listActionButton.borderBottomColor
        },
    })
);

// @ts-ignore
const KegstarExportButton: FunctionComponent<ExportButtonProps> = ({
    sort,
    filter = defaultFilter,
    maxResults = 1000,
    resource,
    onClick,
    label = '',
    icon = defaultIcon,
    ...rest
}) => {
    const exporter = useContext(ExporterContext);
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const classes = useStyles();

    filter['export'] = true;
    filter['tz'] = localStorage.getItem('timezone');

    const handleClick = useCallback(
        event => {
            dataProvider
            // @ts-ignore
                .getList(resource, {
                    sort,
                    filter,
                    pagination: { page: 1, perPage: maxResults },
                })
                .then(
                    // @ts-ignore
                    ({ data }) =>
                        exporter &&
                        exporter(
                            data,
                            fetchRelatedRecords(dataProvider),
                            dataProvider,
                            resource
                        )
                )
                // @ts-ignore
                .catch(error => {
                    console.error(error);
                    notify('ra.notification.http_error', 'warning');
                });
            if (typeof onClick === 'function') {
                onClick(event);
            }
        },
        [
            dataProvider,
            exporter,
            filter,
            maxResults,
            notify,
            onClick,
            resource,
            sort,
        ]
    );

    return (
        <Button
            onClick={handleClick}
            label={''}
            className={classes.button}
            {...sanitizeRestProps(rest)}
        >
            {icon}
        </Button>
    );
};

const defaultIcon = <DownloadIcon />;
const defaultFilter = {};

const sanitizeRestProps = ({
    basePath,
    exporter,
    ...rest
}: Omit<
    ExportButtonProps,
    'sort' | 'filter' | 'maxResults' | 'resource' | 'label'
>) => rest;

interface Props {
    basePath?: string;
    exporter?: (
        data: any,
        fetchRelatedRecords: (
            data: any,
            field: string,
            resource: string
        ) => Promise<any>,
        dataProvider: DataProvider
    ) => Promise<void>;
    filter?: any;
    icon?: JSX.Element;
    label?: string;
    maxResults?: number;
    onClick?: (e: Event) => void;
    resource?: string;
    sort?: Sort;
}

export type ExportButtonProps = Props & ButtonProps;
// @ts-ignore
KegstarExportButton.propTypes = {
    basePath: PropTypes.string,
    exporter: PropTypes.func,
    filter: PropTypes.object,
    label: PropTypes.string,
    maxResults: PropTypes.number,
    resource: PropTypes.string.isRequired,
    sort: PropTypes.exact({
        field: PropTypes.string,
        order: PropTypes.string,
    }),
    icon: PropTypes.element,
};

export default KegstarExportButton;
